import * as Yup from "yup";

export const LoginSchema = Yup.object({
    username: Yup.string().required("Enter Username"),
    password: Yup.string().required("Enter Password"),
});

// Portal: "Please provide username"
export const ForgotPasswordStep1Schema = Yup.object({
    username: Yup.string().trim().required("Please provide username"),
});

// Portal checks: "Password field is empty" / "Passwords are not equal"
export const ForgotPasswordResetSchema = Yup.object({
    newPassword: Yup.string().required("Password field is empty"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords are not equal")
        .required("Confirm your password"),
});
